const initialStoreState = {
  ignoreQuestion1: [],
  ignoreQuestion2: [],
  ignoreQuestion3: [],
  ignoreQuestion4: [],
  ignoreQuestion5: [],
};

const globalFunction = {
  setElement: () => {},
  sketch: null,
};

/*
!!PARAMETERS!!

addQuestion
store.dispatch({type:"addQuestion", key: x(1<=x<=5), state:[1,2,3,4])

resetQuestion
store.dispatch({type:"resetQuestion", key: x(1<=x<=5)})

addAllQuestion
store.dispatch({key:"addAllQuestion", state:{ignoreQuestion1:[1,2], ignoreQuestion2:[3,4],.......,ignoreQuestion5:[5,6]}})

*/

const reducer = (state, action) => {
  // 単一のQuestionをマージ
  if (action.type === "addQuestion") {
    // stateの複製。
    let tempObject = JSON.parse(JSON.stringify(state));
    // ignoreQuestionを指定のkeyでマージ
    // のちArray.form(new Set())で重複した値を削除。
    tempObject[`ignoreQuestion${action.key}`] = Array.from(
      new Set(tempObject[`ignoreQuestion${action.key}`].concat(action.state))
    );
    return tempObject;

    // 単一のQuestionをリセット。
  } else if (action.type === "resetQuestion") {
    // stateの複製。
    let tempObject = JSON.parse(JSON.stringify(state));
    // 指定のkeyのignoreQuestionをリセット。
    tempObject[`ignoreQuestion${action.key}`] = [];
    return tempObject;

    // 全てのQuestionをマージ。
  } else if (action.type === "addAllQuestions") {
    // Stateを複製。
    let tempObject = JSON.parse(JSON.stringify(state));
    Object.keys(tempObject).forEach((key) => {
      const mergedObject = Array.from(
        new Set(tempObject[key].concat(action.state[key]))
      );
      tempObject[key] = mergedObject;
    });
    return tempObject;
  }

  return Object.keys(state).length === 0 ? initialStoreState : state;
};

export const globReducer = (state, action) => {
  switch (action.type) {
    case "addSetElement":
      return { setElement: action.func, sketch: state.sketch };
    case "addOpenEye":
      return { setElement: state.setElement, sketch: action.func };
    default:
      return globalFunction;
  }
};

export default reducer;
